import { i18n } from "discourse-i18n";

export default i18n;
